import { render, staticRenderFns } from "./file-loader-2.vue?vue&type=template&id=975479b2&scoped=true&"
import script from "./file-loader-2.vue?vue&type=script&lang=js&"
export * from "./file-loader-2.vue?vue&type=script&lang=js&"
import style0 from "./file-loader-2.vue?vue&type=style&index=0&id=975479b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975479b2",
  null
  
)

export default component.exports